module.exports = __webpack_public_path__ + "img/ic_checkbox_default_transparent.367ff841.svg";